module.exports = __webpack_public_path__ + "static/media/8351.61863fdb.png";